<nz-form-item>
	<nz-form-label nzRequired nzFor="user" *ngIf="label">{{ label }}</nz-form-label>
	<nz-form-control [nzErrorTip]="errorTip">
		<nz-select nzShowSearch id="user" 
			[nzPlaceHolder]="placeholder"
			[nzLoading]="usersLoading" 
			[nzDisabled]="usersLoading"
			[(ngModel)]="userId"
			[nzDisabled]="disabled"
			(ngModelChange)="changeUser.emit(userId)"
		>
			<ng-container *ngFor="let user of users">
				<nz-option nzCustomContent 
					[nzValue]="user?.uuid"
					[nzLabel]="user?.fName + (user?.fUsername ? ' - ' + user?.fUsername : '')" 
					*ngIf="user?.fName"
				>
					<span [class.text-danger]="user?.fDeleted == 1">
						{{ user?.fName + (user?.fUsername ? ' - ' + user?.fUsername : '') }}
					</span>
				</nz-option>
			</ng-container>
		</nz-select>
	</nz-form-control>
</nz-form-item>